import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StairsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stairs"}/>
}
